import React from 'react';
import { useTranslation } from 'react-i18next';

function Team() {
  const { t } = useTranslation();
  
  const teamMembers = [
    {
      name: t('team.piotr.name'),
      role: t('team.piotr.role'),
      image: 'imgs/piotr.jpg',
      experience: [
        t('team.piotr.exp1'),
        t('team.piotr.exp2'),
        t('team.piotr.exp3')
      ],
      tagline: t('team.piotr.tagline')
    },
    {
      name: t('team.tomasz.name'),
      role: t('team.tomasz.role'),
      image: 'imgs/tomasz.jpg',
      experience: [
        t('team.tomasz.exp1'),
        t('team.tomasz.exp2'),
        t('team.tomasz.exp3')
      ],
      tagline: t('team.tomasz.tagline')
    }
  ];

  const clientLogos = [
    {src: 'imgs/logo-ikea.png', alt: 'ikea'},
    {src: 'imgs/logo-hochland.png', alt: 'hochland'},
    {src: 'imgs/logo-jti.png', alt: 'jti'},
    {src: 'imgs/logo-wff.png', alt: 'wff'},
    {src: 'imgs/logo-steelseries.png', alt: 'steelseries'},
    {src: 'imgs/logo-otomoto.png', alt: 'otomoto'},
    {src: 'imgs/logo-rainbow.png', alt: 'rainbow'},
  ];

  return (
    <section className="section team-section" id="team">
      <div className="container">
        <span className="section-label">{t('team.label')}</span>
        <h2 className="section-title">{t('team.title')}</h2>

        <div className="team-grid">
          {teamMembers.map((member) => (
            <div className="team-member animate-on-scroll" key={member.name}>
              <div className="team-image">
                <img src={`/${member.image}`} alt={member.name} />
              </div>
              <div className="team-info">
                <h3 className="team-name">{member.name}</h3>
                <h4 className="team-role">{member.role}</h4>
                <ul className="team-experience">
                  {member.experience.map((exp, index) => (
                    <li key={index}>{exp}</li>
                  ))}
                </ul>
                <p className="team-tagline">{member.tagline}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="consultant-network">
          <h3>{t('team.network')}</h3>
          <p>{t('team.networkDesc')}</p>
        </div>

        <div className="clients-section">
          <h3>{t('team.clientsTitle')}</h3>
          <div className="client-logos">
            {clientLogos.map((logo, index) => (
              <img 
                key={index}
                src={`/${logo.src}`} 
                alt={`${logo.alt}`}
                className="client-logo" 
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default Team;
